import{Divider as p,packSx as n}from"@mantine/core";import{jsx as d}from"@emotion/react/jsx-runtime";function r(e){let{sx:i,height:t,...o}=e;return d(p,{sx:[{height:t},...n(i)],...o})}export{r as Divider};
